<template>
  <div :class="['container', { fluid, centered }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    fluid: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.container {
  width: 88%;
  margin-left: auto;
  margin-right: auto;

  &.fluid {
    width: 100%;
  }

  &.centered {
    display: flex;
    justify-content: center;
  }
}
</style>
